<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="12">
            <a-form-item label="用户编号">
              <a-input allow-clear v-model="query.appearanceNo" placeholder="请输入用户编号" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="开始波动率">
              <a-input v-model="query.startFluctuationRatio" placeholder="请输入开始波动率查询" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="结束波动率">
              <a-input v-model="query.endFluctuationRatio" placeholder="请输入结束波动率查询" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="exportHandle()" v-action:export>导出</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table size="middle" rowKey="id" bordered
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)" :data-source="list"
      :columns="columns" :loading="dataListLoading" :pagination="pagination" @change="pageChange">
      <template slot="fluctuationRatioAction" slot-scope="text">
        <span>{{ text }}%</span>
      </template>
    </a-table>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import { PERMISSION_ENUM } from '@/core/permission/permission'

const columns = [
  {
    title: '用户编号',
    dataIndex: 'appearanceNo'
  },
  {
    title: '用户名称',
    width: '300px',
    dataIndex: 'name'
  },
  {
    title: '昨天用水量',
    dataIndex: 'yesterdayMeterNumber'
  },
  {
    title: '前天用水量',
    dataIndex: 'frontdayMeterNumber'
  },
  {
    title: '波动数据(吨)',
    dataIndex: 'meterNumber'
  },
  {
    title: '增长率',
    dataIndex: 'fluctuationRatio',
    scopedSlots: { customRender: 'fluctuationRatioAction' }
  }
]

export default {
  components: {},
  mixins: [mixinViewModule],
  name: 'WaterFluctuation',
  data () {
    return {
      collectionTime: [],
      pushTime: [],
      manuList: [],
      queryUrl: '/pipe-network/yc_user_remote_water_meters/data/water_meter/sort',
      queryOneUrl: 'pipe-network/meter-history',
      deleteUrl: 'pipe-network/meter-history',
      exportDataUrl: 'pipe-network/yc_user_remote_water_meters/data/export/water_meter/sort',
      exportFileName: '用水量波动列表数据.xlsx',
      query: {
        appearanceNo: '',
        startFluctuationRatio: '',
        endFluctuationRatio: ''
      },
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      columns
    }
  },
  created () { },
  methods: {},
  watch: {}
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

.tenant-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

/deep/.ant-table-thead>tr>th> {
  text-align: center;
}

/deep/.ant-table-tbody>tr>td {
  text-align: center;
}
</style>
